import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {WarningComponent} from "../../../../../../shared/components/warning/warning.component";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Message} from "../../../../../../core/class/message";
import {ToastrService} from "ngx-toastr";
import {DocumentService} from "../../../../../../core/services/document.service";
import {NotificationService} from "../../../../../../core/services/notification.service";
import {Subscription} from "rxjs";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-decline-initial-sign',
  templateUrl: './decline-initial-sign.component.html',
  styleUrls: ['./decline-initial-sign.component.scss']
})
export class DeclineInitialSignComponent implements OnInit, AfterViewInit {
  document = {
    id: 0,
    reason: ''
  };
  formChangesSubscription: Subscription;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<DeclineInitialSignComponent>,
    public notificationService: NotificationService,
  ) {
    this.document = data;

  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  declineInitialSignDocument() {
    this.documentService.declineInitialSignDocument(this.document).subscribe(rs => {
      this.success = true;
      // refuse_sign_success
      this.toastr.success(this.message.getMessage('messages.refuse_initial_success'));
      this.dialogRef.close(true);
    });
  }

}
